import React, { useState, createContext, useContext } from 'react';
import { Screen } from '../types';
type NavigationParams = Record<string, any>;
interface NavigationState {
  screen: Screen;
  params?: NavigationParams;
}
interface NavigationContextType {
  currentScreen: Screen;
  currentParams?: NavigationParams;
  navigate: (screen: Screen, params?: NavigationParams) => void;
  goBack: () => void;
  resetTo: (screen: Screen, params?: NavigationParams) => void;
}
const NavigationContext = createContext<NavigationContextType | undefined>(undefined);
export function NavigationProvider({
  children
}: {
  children: ReactNode;
}) {
  const [history, setHistory] = useState<NavigationState[]>([{
    screen: Screen.SPLASH
  }]);
  const current = history[history.length - 1];
  const navigate = (screen: Screen, params?: NavigationParams) => {
    setHistory(prev => [...prev, {
      screen,
      params
    }]);
  };
  const goBack = () => {
    setHistory(prev => prev.length > 1 ? prev.slice(0, -1) : prev);
  };
  const resetTo = (screen: Screen, params?: NavigationParams) => {
    setHistory([{
      screen,
      params
    }]);
  };
  return <NavigationContext.Provider value={{
    currentScreen: current.screen,
    currentParams: current.params,
    navigate,
    goBack,
    resetTo
  }} data-id="element-165">
      {children}
    </NavigationContext.Provider>;
}
export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) throw new Error('useNavigation must be used within NavigationProvider');
  return context;
};